import React, {useState } from 'react';
import { Link } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import { reportService } from '../../Services';

import {ReactComponent as Loading} from '../../images/icons/General/loading-01.svg';

export const CommProblems = () => {
    const [report, setReport] = useState();
    const [dateStart, setDateStart] = useState();
    const [dateEnd, setDateEnd] = useState(new Date());
    const [loading, setLoading] = useState(false);
    

    const handleReport = async () => {
            if (dateStart && dateEnd) {
                setLoading(true);
                const res = await reportService.commProblemsReport({
                    dateStart: moment(dateStart).format('DD-MM-YYYY'),
                    dateEnd: moment(dateEnd).format('DD-MM-YYYY')
                });
    
                if (res) 
                    setReport(res)
                
                setLoading(false);
            }
        }

    return (
        <>
            <h1 id="report-title">AOP Comm Problems Report</h1>
            <div className="bordered-content">
                <div className="header">
                    <div className="select-year sentence">
                        
                        From <DatePicker name="date" selected={dateStart} onChange={setDateStart} placeholderText="Select date" className="required" isClearable /><br className="mobile" />
                        until <DatePicker name="date" selected={dateEnd} onChange={setDateEnd} placeholderText="Select date" className="required" isClearable /><br className="mobile" />
                        <button className="primary" type="button" onClick={handleReport}>{loading ? <Loading className="btn-loader"alt="loader" /> : ''}Generate report</button>
                    </div>
                </div>
            </div>
            {report ? <div id="report">
                <div className="bordered-content mt-32">
                    <div className="header">
                    <p>Total Presentation Dives: {report.divesTotal}, with Comm/Audio problems: {report.problemsTotal} {report.problemsTotal && report.divesTotal  ? '(' + (report.problemsTotal/report.divesTotal * 100).toFixed(2) + '%)' : ''}</p>
                    </div>
                    <table>
                        <thead>
                            <tr className="desktop">
                                <th>Date</th>
                                <th>Start time</th>
                                <th>Location</th>
                                <th>Diver</th>
                                <th>Gear</th>
                                <th>Mask/Comm #</th>
                                <th style={{width: '30%'}}>Comm Report</th>
                            </tr>
                        </thead>
                        <tbody>
                            {report.problems.map((item, key) => {
                                return (
                                    <tr key={key}>
                                        <td><Link to={`/configuration/users/${item.UserID}/dives/${item.DiveID}`}>{item.DiveDate}</Link></td>
                                        <td>{item.DiveTime}</td>
                                        <td>{item.Location}</td>
                                        <td>{item.LastName}, {item.FirstName}</td>
                                        <td>{item.Gear}</td>
                                        <td>{item.CommMask}</td>
                                        <td>
                                            {item.CommProblems}
                                            {item.CommProblems && item.problems && '<br />'}
                                            {item.problems}
                                        </td>
                                    </tr>
                                )}
                            )}
                        </tbody>
                    </table>
                </div>
            </div> : ''}
        </>
    );
};

export default CommProblems;